const getPartyCard = (state, start, end) => {
  if (state.card !== undefined && state.card.cardNumber !== undefined) {
    return state.card.cardNumber.substring(start, end)
  } else {
    return ''
  }
}

const getMonthDesc = (month) => {
  switch (month) {
    case 1:
      return 'Janeiro'
    case 2:
      return 'Fevereiro'
    case 3:
      return 'Março'
    case 4:
      return 'Abril'
    case 5:
      return 'Maio'
    case 6:
      return 'Junho'
    case 7:
      return 'Julho'
    case 8:
      return 'Agosto'
    case 9:
      return 'Setembro'
    case 10:
      return 'Outubro'
    case 11:
      return 'Novembro'
    case 12:
      return 'Dezembro'
    default:
      return ''
  }
}

const cardNumberPart1 = (state) => {
  return getPartyCard(state, 0, 4)
}

const cardNumberPart2 = (state) => {
  return getPartyCard(state, 4, 8)
}

const cardNumberPart3 = (state) => {
  return getPartyCard(state, 8, 12)
}

const cardNumberPart4 = (state) => {
  return getPartyCard(state, 12, 16)
}

const cardExpiration = (state) => {
  if (state.card !== undefined &&
      state.card.cardYearExpiry !== undefined &&
      state.card.cardYearExpiry !== '' &&
      state.card.cardMonthExpiry !== undefined &&
      state.card.cardMonthExpiry !== ''
  ) {
    return `${state.card.cardMonthExpiry.toString().padStart(2, '0')}/${state.card.cardYearExpiry}`
  } else {
    return ''
  }
}

const cardCreatedAtDesc = (state) => {
  if (state.card !== undefined && state.card.cardCreatedAt !== undefined) {
    let date = new Date(state.card.cardCreatedAt)
    return `${date.getDate()} de ${getMonthDesc(date.getMonth() + 1)} de ${date.getFullYear()}`
  } else {
    return ''
  }
}

export default {
  cardNumberPart1,
  cardNumberPart2,
  cardNumberPart3,
  cardNumberPart4,
  cardExpiration,
  cardCreatedAtDesc
}



// WEBPACK FOOTER //
// ./src/features/admin/astroPay/store/getters.js